import { observer } from "mobx-react-lite"
import { EditorSteps } from "../editor-utils/editor-types"
import { TruncateString } from "../editor-utils/id-string-utils"
import { generateSteps } from "./steps-generator"
import asEditorStore from "./../local-store/asset-section-editor-store"
import { Icon } from "@metsooutotec/modes-react-components"
import {
    LinerDrawingReference,
    LinerLocation,
    PutLinerLocation,
    PutLinerRegion,
} from "features/organizations/asset-sections/models/asset-section-models"

export const SideBarContents: React.FC = observer(() => {
    const { currentStep, selectedLiners, selectedWearReferencePlane, selectedholes, selectedLinersDrawingRef } = asEditorStore

    const steps = generateSteps(selectedLiners, selectedWearReferencePlane, selectedholes, selectedLinersDrawingRef)
    const charLong = currentStep === EditorSteps.LinersLocation ? 12 : 22

    const displayValues = (pair: any) => {
        switch (currentStep) {
            case EditorSteps.LinersLocation:
                return {
                    first: TruncateString((pair as PutLinerLocation).existReference, charLong),
                    second: (pair as PutLinerLocation).newReference,
                }

            case EditorSteps.WearReferencePlane:
                return {
                    first: TruncateString((pair as LinerLocation).reference, charLong),
                    second: (pair as LinerLocation).wallThickness,
                }

            case EditorSteps.LinersDrawingReferences:
                const DRef = pair as LinerDrawingReference
                return {
                    first: TruncateString(DRef.linerReference, charLong),
                    second: DRef.newDrawingReferenceName,
                }
            case EditorSteps.HolesLocation:
                const Rhole = pair as PutLinerRegion
                return {
                    first: TruncateString(Rhole.existReference, charLong),
                    second: Rhole.newReference,
                }
        }
        return { first: "", second: "" }
    }

    return (
        <>
            {steps[currentStep]?.sideBarList?.map((pair, index) => {
                const { first, second } = displayValues(pair)
                return (
                    <div key={index} className='idPairRectangle'>
                        <span>{first}</span>
                        <Icon className='hole-change-spacer' name='icon-arrow-right-16' />
                        <span>{second}</span>
                    </div>
                )
            })}
        </>
    )
})
